import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { STATIC_BASE_URL } from './constants';

const blockmapsDataURL = `${STATIC_BASE_URL}/blockmaps/blockmaps.json`;

async function setupTable() {
  // Data table columns.
  const sample_columns = [
    { title: 'Block', field: 'block', headerFilter: true },
    { title: 'Year', field: 'year', headerFilter: true },
    { title: 'File number', field: 'fileNumber', headerFilter: true },
    { title: 'File type', field: 'fileType', headerFilter: true },
    {
      title: 'Download',
      field: 'url',
      headerSort: false,
      formatter: 'link',
      formatterParams: {
        label: 'Link',
        target: '_blank',
      },
    },
  ];

  // create Tabulator on DOM element with ID `blockmaps-table`
  const table = new Tabulator('#blockmaps-table', {
    layout: 'fitColumns', //fit columns to width of table (optional)
    columns: sample_columns,
    pagination: true,
  });

  console.log(table);

  const response = await fetch(blockmapsDataURL);
  const blockmapsData = await response.json();

  table.setData(blockmapsData);

}

setupTable();
